import { render, staticRenderFns } from "./practice-overview-point.vue?vue&type=template&id=39bce628&scoped=true"
import script from "./practice-overview-point.vue?vue&type=script&lang=js"
export * from "./practice-overview-point.vue?vue&type=script&lang=js"
import style0 from "./practice-overview-point.vue?vue&type=style&index=0&id=39bce628&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bce628",
  null
  
)

export default component.exports